import {useState} from 'react';
import './ranking.css';

import {useFetch} from '../../hooks/useFetch'
import Loading from '../../components/Loading';
import Header from '../../components/Header';
import Footer from '../../components/MFooter';

import RankingMunicipio2 from './RankingMunicipio2';
import RankingEduca from './RankingEduca';

function Page(){

    return (
        <>
            <Header/>
            <Ranking/>
            <Footer/>
        </>
    )
}

export default Page;


// const modos = ['Global', 'Municipio']
const modos = {
    GLOBAL:"Global",
    MUNICIPIO:"Município",
    EDUCA:"Educação"
}
function Ranking() {
    // const modos_values = ['Global']
    const modos_values = Object.values(modos);
    // const modos_values = ['Global']//, 'Local', 'Municipio']
    const [modoAtv, setModoAtv] = useState(modos_values[2]) // Modo ativado
    // const {data:RankingData} = useFetch(`ranking/${modoAtv}`)

    return (<div className='ranking'>
        <RankingHeader
            modoAtv={modoAtv}
            setModoAtv={setModoAtv}
            modosV={modos_values}
        />
        <RankingBody
            modoAtv={modoAtv}
            // RankingData={RankingData}
            // setModoAtv={setModoAtv}
            // modos={modos}
        />
        {/* <RankingFooter/> */}
    </div>)
}


export function RankingHeader({titulo, modoAtv, setModoAtv, modosV}){

    const lista_menu = modosV.map(modo => {
        return <li
            name = {modo}
            key = {`modo_${modo}`}
            onClick = {()=>setModoAtv(modo)}
            className={`ranking-header-btn ${modo===modoAtv ? 'btn-checked' : ''}`}
            >{modo}</li>
    })

    return(<>
        <div className = 'ranking-header'>
            <h1> {titulo||"Ranking"} </h1>
            <ul className='ranking-header-btns'>
                {lista_menu}
            </ul>
        </div>

    </> );
}

export function Bloco (props) {
    const {pos, username, pontos, municipio, nome} = props;
    return(
        <div className='ranking-bloco' title={nome}>
            <div className='ranking-dados'>
                <div className='ranking-icone-pos'>
                    <i>{pos}</i>
                </div>
                <div className='ranking-dados-texto'>
                    <p className='ranking-dados-texto-nome'>{nome}</p>
                    <p className='ranking-dados-texto-username'>@{username}</p>
                    <p className='ranking-dados-texto-municipio'>{municipio}</p>
                </div>
            </div>
            <div className='ranking-pontos'>
                <p>{pontos}<span className='ranking-pontos-makes'>inovaCoins</span></p>
            </div>
            {/* <div className='ranking-medalhas'>
                {medalhas[0]}
                {medalhas[1]}
                {medalhas[2]}
            </div> */}
        </div>
    );
}

function RankingBody({ modoAtv }){
    //modoAtv modos
    // const {data:RankingData} = useFetch(`ranking/${modoAtv}`)
    // if (!RankingData) {
    //     return <Loading texto='Carregando informações' />
    // }

    return ( <>
        {(modoAtv===modos.GLOBAL)&&
            <RankingGlobal/>
        }
        {(modoAtv===modos.MUNICIPIO)&&
            <RankingMunicipio2/>
        }
        {(modoAtv === modos.EDUCA)&&
            <RankingEduca />
        }
    </> )
}


function RankingGlobal(){
    const { data: RankingData } = useFetch(`ranking`)

    if (!RankingData) {
        return <Loading texto='Carregando informações' />
    }

    const RankingData_sort = RankingData.sort((a,b) => -a.pontos+b.pontos)

    return (<>
        <p>Aviso: O Ranking está sendo atualizado uma vez por dia</p>

        <div className='ranking-body'>
            {RankingData_sort.map((blocoData,pos)=>{
                return (<Bloco
                    key={`bloco_id_${pos}`}
                    pos={pos+1}
                    username={blocoData.username}
                    pontos={blocoData.pontos}
                    municipio={blocoData.municipio}
                    nome ={blocoData.nome}
                    />)
                })}
        </div>

    </>)
}
